export default __webpack_public_path__ + "static/media/aboutbg.3ecd3e97.jpg";